module.exports = __webpack_public_path__ + "static/media/aerovinum-5.d2da4686.jpg";